import React from 'react';
import { Link } from 'dva/router';
import styles from './index.css';

class Tail extends React.Component {
	render() {
		const currentYear = new Date().getFullYear();
		const currentHost = window.location.host;
		return (
			<div className={styles.foot_wrap_style}>
				<div className={styles.footer}>
					<Link to="/about#intro" >关于长歌</Link>
					<Link to="/about#contact" >联系我们</Link>
					{/* <a onClick={() => {
						window.open('https://www.zhipin.com/gongsi/29faa9a6c0a24b8e03d939m6.html?ka=search_rcmd_company_29faa9a6c0a24b8e03d939m6');
					}}> 加入我们</a> */}
					{/* <a onClick={() => {
						window.open('https://img.wandu.cn/fe/pc_download/download.html');
					}}>下载APP</a> */}
				</div>
				{/* <div className={styles.friendly_box}>
					<span className={styles.friendly_title}>友情链接:</span>
					<a className={styles.friend_item} target='_blank' rel="noopener noreferrer" href="https://www.51changdu.com/">畅读</a>
					<a className={styles.friend_item} target='_blank' rel="noopener noreferrer" href="https://www.heiyan.com/">黑岩</a>
				</div> */}
				<div className={styles.declare_box}>
					<section className={styles.declare_text}>
						<p>请所有作者发布作品时务必遵守国家互联网信息管理办法规定，我们拒绝任何色情小说，一经发现，即刻删除！</p>
						<p>本站所收录的作品、社区话题、用户评论、用户上传内容或图片等均属用户个人行为。如前述内容侵害您的权益，欢迎举报投诉，一经核实，</p>
						<p>立即删除，本站不承担任何责任</p>
					</section>
					<section className={styles.state_text}>
						<p>Copyright (C) 2024-{currentYear}  {currentHost} All rights reserved </p>
						{/* <p >
							<a href="https://img.wandu.cn/fe/pc/static/media/BusinessLicense.jpg" target="_blank" rel="noopener noreferrer" style={{ color: '#000' }}>
								营业执照：<img src="https://img.wandu.cn/fe/pc/static/media/iconaa.png" alt="" style={{ width: '20px', marginRight: '6px', position: 'relative', top: '-2px' }} />
							</a>
							<a href="https://img.wandu.cn/fe/pc/static/media/newPublicationLicense.jpg" target="_blank" rel="noopener noreferrer" style={{ color: '#000', marginRight: '6px' }}>
								出版物经营许可证：新出发渝涪字第074号
							</a>
							<a href='https://beian.miit.gov.cn/#/Integrated/recordQuery' target='_blank' rel="noopener noreferrer" style={{ color: '#000' }}>
								渝ICP备17003661号-3
							</a>
						</p> */}
						{/* <p>不良信息举报电话：010-84856481</p> */}
					</section>
				</div>
			</div>);
	}
}

export default Tail


// WEBPACK FOOTER //
// ./src/layout/app/tail.js